module.exports = __webpack_public_path__ + "img/35771931234507.564a1d2403b3a.bb74deec.gif";